import React from "react";

/* Placeholder for admin sections that haven't been built yet. */
export function ComingSoonPage({ title, description, icon: Icon, accent = "#00A3E0" }) {
  return (
    <div data-testid={`page-${title.toLowerCase()}`} className="min-h-screen bg-paper">
      <div className="bg-stock border-b border-ink px-5 sm:px-8 py-6">
        <h1 className="font-display font-bold text-3xl tracking-[-0.02em] text-ink">{title}</h1>
      </div>
      <div className="px-5 sm:px-8 py-16 sm:py-24">
        <div className="max-w-lg border border-dashed border-ink bg-stock p-8 sm:p-10">
          <div className="w-12 h-12 flex items-center justify-center rounded-[3px]" style={{ backgroundColor: accent, color: "#161616" }}>
            <Icon size={24} aria-hidden="true" />
          </div>
          <h2 className="mt-6 font-display font-bold text-2xl text-ink">{title} isn't built yet</h2>
          <p className="mt-3 text-graphite leading-relaxed">{description}</p>
          <p className="mt-6 text-sm text-graphite">Until then, use Leads and Orders for day-to-day work.</p>
        </div>
      </div>
    </div>
  );
}
